import { ConfirmSwal, SuccessSwal } from '@vendor/libs/sweetalert2/sweetalert2';
import { i18n } from '@vendor/libs/lang/lang';
import { Spinner } from '@vendor/js/spinner';
import Common from '@vendor/js/common';
import { Api } from '@vendor/js/api';
import ApplicationStatus from '@vendor/js/enums/ApplicationStatus';
const _ApplicationsEditHandler = (function () {
    const setupApplicationCancelButton = (selector, cancelUrl) => {
        $(selector).on('click', function () {
            ConfirmSwal.fire({
                text: i18n.trans('models/applications.pages.show.confirm_cancel'),
            }).then(async (response) => {
                if (response.isConfirmed) {
                    const spinner = new Spinner();
                    try {
                        const response = await Api.post(cancelUrl);
                        if (response) {
                            SuccessSwal.fire({
                                text: i18n.trans(response.message ??
                                    'models/applications.pages.show.cancel_success'),
                            }).then(() => {
                                if (response.redirect) {
                                    window.location.href = response.redirect;
                                }
                            });
                        }
                    }
                    catch (err) {
                        Common.handleErrorResponse(err);
                    }
                    finally {
                        spinner.destroy();
                    }
                }
            });
        });
    };
    const setupApplicationConfirmSubmitButton = (selector) => {
        const form = $(selector);
        let shouldPrevent = true;
        form.find('button[type="submit"]').on('click', function (e) {
            if (shouldPrevent) {
                e.preventDefault();
                const value = form.find('[name="status"]:checked').val();
                let text = i18n.trans('common.forms.confirm');
                if (value == ApplicationStatus.ACCEPTED.value) {
                    text = i18n.trans('models/applications.pages.show.confirm_accept');
                }
                else if (value == ApplicationStatus.REJECTED.value) {
                    text = i18n.trans('models/applications.pages.show.confirm_reject');
                }
                ConfirmSwal.fire({
                    html: text,
                }).then((response) => {
                    if (response.isConfirmed) {
                        shouldPrevent = false;
                        $(this).trigger('click');
                    }
                });
            }
            else {
                shouldPrevent = true;
            }
        });
    };
    return {
        // Public functions
        init: function () { },
        setupApplicationCancelButton,
        setupApplicationConfirmSubmitButton,
    };
})();
window.ApplicationsEditHandler = _ApplicationsEditHandler;
